import React from 'react';
import { Hero } from './components/Hero';
import { ForYou } from './components/ForYou';
import { ProblemSection } from './components/ProblemSection';
import { Modules } from './components/Modules';
import { Bonuses } from './components/Bonuses';
import { Projects } from './components/Projects';
import { Testimonials } from './components/Testimonials';
import { OfferCard } from './components/OfferCard';
import { NextSteps } from './components/NextSteps';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { SiteFooter } from './components/SiteFooter';
import { useCountdown } from './hooks/useCountdown';
import { MetaPixel } from './components/MetaPixel';
import { PurchasePopup } from './components/PurchasePopup';
interface AppProps {
  /** Show the placeholder countdown above the offer card. */
  showCountdown?: boolean;
}
export function App({
  showCountdown = true
}: AppProps) {
  const countdown = useCountdown(30);
  return <div className="w-full bg-cream font-sans text-ink" data-id="element-0" data-mp="3ijxqiu0iq6lh">
      <MetaPixel data-id="element-1" data-mp="3ijfvu1ti80fo" />
      <PurchasePopup data-id="element-2" data-mp="3ihv2gfixenje" />
      <Hero countdown={countdown} data-id="element-3" data-mp="3mlj98vzqhf3l" />
      <main data-id="element-4" data-mp="3mkhm3t5g125i">
        <ForYou data-id="element-5" data-mp="3mk83iqmq9x9u" />
        <ProblemSection data-id="element-6" data-mp="3mjq45l4rr2xp" />
        <Modules data-id="element-7" data-mp="3rc9d24sih9w6" />
        <Bonuses data-id="element-8" data-mp="3rbrayrj641gc" />
        <Projects data-id="element-9" data-mp="3rdas0kcnegj6" />
        <Testimonials data-id="element-10" data-mp="3rcswjpxt86cb" />
        <OfferCard showCountdown={showCountdown} countdown={countdown} data-id="element-11" data-mp="3reltuemj9e7n" />
        <NextSteps data-id="element-12" data-mp="5ggje8nxyxz" />
        <Faq data-id="element-13" data-mp="82jf0klzq9v" />
        <FinalCta data-id="element-14" data-mp="2zl3alhpbj03q" />
      </main>
      <SiteFooter data-id="element-15" data-mp="2zlv7qwykd5w4" />
    </div>;
}